// components/ProfileStats.jsx
import React from 'react';
import { Row, Col } from 'reactstrap';

const ProfileStats = ({ mentors, mentees }) => {
  return (
    <Row className="pt-5">
      <Col md={3} lg={3}>
        <span id="mentors_count">Number of Mentors</span>

        <dd className="fw-medium">{mentors}</dd>
      </Col>
      <Col md={3} lg={3}>
        <span id="mentee_count">Number of Mentees</span>
        <dd className="fw-medium">{mentees}</dd>
      </Col>
    </Row>
  );
};

export default ProfileStats;
